import Script, { ScriptProps } from 'next/script';
import { ReactNode } from 'react';
import { Loader } from '../..';
import { UseLoadStateReturn } from '../../../hooks/useLoadState';

export type LoadScriptProps = Omit<ScriptProps, 'onLoad' | 'onError'> & {
  control: UseLoadStateReturn;
  children?: ReactNode;
  loader?: React.ComponentType;
  fallback: ReactNode | ((err: unknown) => ReactNode);
};

export function LoadScript({
  control,
  children,
  loader: LoaderComponent = Loader as React.ComponentType, // TODO: why the heck doesn't it allow me this assignment without type cast
  fallback,
  ...props
}: LoadScriptProps) {
  const unifiedFallback = typeof fallback === 'function' ? fallback : () => fallback;
  return (
    <>
      <Script {...props} onLoad={control.onLoad} onError={control.onError} />
      {control.isLoading && <LoaderComponent />}
      {control.loaded && children}
      {!!control.error && unifiedFallback(control.error)}
    </>
  );
}
